import { useEffect, useRef, useState } from 'react';

/**
 * Reveal-on-scroll hook. Returns [ref, isVisible].
 * `delay` lets sibling reveals stagger.
 */
export function useScrollReveal({ threshold = 0.15, delay = 0, once = true } = {}) {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    if (delay > 0) setTimeout(() => setIsVisible(true), delay);
                    else setIsVisible(true);
                    if (once) observer.unobserve(el);
                } else if (!once) {
                    setIsVisible(false);
                }
            },
            { threshold }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [threshold, delay, once]);

    return [ref, isVisible];
}
